var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    id: "g1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2341 45.2663C79.6895 44.4786 78.7875 44 77.8166 44C77.3191 44 76.8255 44.1281 76.3892 44.3702L64.2402 51.1262L50.7663 51.1012L50.4404 51.1122C47.9635 51.2802 46 53.3486 46 55.8675V87.2337L46.011 87.5596C46.179 90.0365 48.2475 92 50.7663 92H86.472L86.7978 91.989C89.2748 91.821 91.2383 89.7525 91.2383 87.2337V78.2204H93.3238L93.5222 78.022V66.3739L93.3238 66.1755H91.2383V55.8676L91.2273 55.5418C91.0593 53.0648 88.9908 51.1013 86.472 51.1013H83.4953L80.3864 45.5117L80.2341 45.2663ZM50.7663 53.3252H60.2864L56.5734 55.39L51.3373 55.365C50.7228 55.365 50.2253 55.8628 50.2253 56.477C50.2253 57.0913 50.7228 57.5891 51.3373 57.5891H89.0142V66.1764H82.5317C79.3195 66.1764 76.7056 68.7903 76.7056 72.0024V72.3953C76.7056 75.6075 79.3196 78.2214 82.5317 78.2214H89.0142V87.2337C89.0142 88.6352 87.8733 89.7761 86.4718 89.7761H50.7663C49.3648 89.7761 48.2239 88.6352 48.2239 87.2337V55.8676C48.2239 54.4662 49.3648 53.3252 50.7663 53.3252ZM91.2982 68.3993H82.5317C80.5454 68.3993 78.9295 70.0152 78.9295 72.0014V72.3943C78.9295 74.3806 80.5455 75.9965 82.5317 75.9965H91.2982V68.3993ZM85.5283 72.2729C85.5283 71.0493 84.5366 70.0572 83.3128 70.0574C82.0887 70.0574 81.0972 71.0489 81.0972 72.2729C81.0972 73.497 82.0886 74.4885 83.3128 74.4885C84.5369 74.4885 85.5283 73.4971 85.5283 72.2729ZM86.472 53.3252H84.7325L85.866 55.3649H88.9507L88.8882 55.1186C88.5669 54.0735 87.6013 53.3252 86.472 53.3252ZM61.1953 55.364L77.4714 46.3137C77.8024 46.1281 78.2583 46.2592 78.4424 46.5914L83.3215 55.364H61.1953Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.c9e32831.svg";
export { ForwardRef as ReactComponent };